module.exports = __webpack_public_path__ + "static/media/SSDash.56eadb81.png";